// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko'
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue'
import App from './App'
import router from './router'

import $ from 'jquery'
import layer from 'vue-layer'
import "vue-layer/lib/vue-layer.css";
Vue.prototype.$layer = layer(Vue);
import store from "./store"
import '../static/css/bootstrap.min.css';
import '../static/css/global.css';

import axios from 'axios'
import numbro from 'numbro';

import VueI18n from 'vue-i18n'
import ko from './vueI18n/ko'
import en from './vueI18n/en'
import mg from './vueI18n/mg'


Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
Vue.prototype.formatMoney = function (num, mantissa) {
      const params = {
        thousandSeparated: true
      }
      if (typeof mantissa !== 'undefined') {
        Object.assign(params, { mantissa })
      }
      return numbro(num || 0).format(params)
}
// import filters from "./components/filter.js"
// Object.keys(filters).forEach(key=>{
//   Vue.filter(key,filters[key])
// })
// 引入全局配置文件
import $conf from "../config/config.js"
import $confMg from "../config/config_mg.js"
import $confEn from "../config/config_en.js"
Vue.prototype.$conf = $conf
Vue.prototype.$confMg = $confMg
Vue.prototype.$confEn = $confEn
Vue.use(ElementUI, { locale })
Vue.use(VueI18n)

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'ko', 
  messages:{
    'ko':ko,
    'en':en,
    'mg':mg,
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
    beforeCreate() {
        Vue.prototype.$bus = this
    },
  components: { App },
  template: '<App/>'
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js